<template>
  <div>
    <el-card shadow="false" style="padding-top: 22px; margin-bottom: 20px">
      <el-form ref="form" :model="form" label-width="160px" inline>
        <el-form-item label="Bureau Name">
          <el-select
            v-model="form.bureauName"
            style="width: 220px"
            @change="handleBureauNameSelectChange"
          >
            <el-option
              v-for="item in bureauNameList"
              :key="item.label"
              :value="item.value"
              :label="item.label"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="Product Name">
          <el-select v-model="form.productName" style="width: 220px">
            <el-option
              v-for="item in disposeProductNameList"
              :key="item.label"
              :value="item.value"
              :label="item.label"
            />
          </el-select>
        </el-form-item>
      </el-form>
    </el-card>
    <el-card header="EVENT DATA" shadow="false">
      <brazil-lookup ref="3" v-if="form.productName === 3" />
      <brazil-report
        ref="4"
        v-show="form.productName === 4"
        :defaultQuery="defaultQuery"
      />
      <global-lookup ref="1" v-if="form.productName === 1" />
      <global-data-packet ref="2" v-if="form.productName === 2" />
      <monitor-financial-report ref="7" v-show="form.productName === 7" />
      <monitor-detail-report ref="6" v-show="form.productName === 6" />
      <monitor-search-by-name ref="5" v-show="form.productName === 5" />
      <monitor-search-by-ticker ref="8" v-show="form.productName === 8" />
      <monitor-search-by-phone ref="9" v-show="form.productName === 9" />
    </el-card>
    <div class="footer">
      <customize-button
        style="margin-right: 16px"
        @click="
          $router.push({
            name: 'bureau-report',
            params: {
              customerId: $route.params.customerId,
            },
          })
        "
      >
        Cancel
      </customize-button>
      <customize-button
        :loading="btnLoading"
        type="primary"
        @click="handleClickSubmitBtn"
      >
        Submit Event
      </customize-button>
    </div>
  </div>
</template>

<script>
import {
  BrazilLookup,
  BrazilReport,
  GlobalLookup,
  GlobalDataPacket,
  MonitorFinancialReport,
  MonitorDetailReport,
  MonitorSearchByName,
  MonitorSearchByTicker,
  MonitorSearchByPhone,
} from './components'

import { save } from './api'

const BRAZIL_VALUES = [3, 4]
const BRADSTREET_GLOBAL_VALUES = [1, 2]
const CREDIT_RISK_MONITOR_VALUES = [5, 6, 7, 8, 9]

export default {
  data() {
    return {
      form: {
        bureauName: 2,
        productName: 1,
      },
      bureauNameList: [
        {
          label: 'D&B Brazil',
          value: 1,
        },
        {
          label: 'Dun & Bradstreet Global',
          value: 2,
        },
        {
          label: 'Credit Risk Monitor',
          value: 3,
        },
      ],
      productNameList: [
        {
          label: 'Lookup',
          value: 1,
        },
        {
          label: 'Global Data Packet/Report',
          value: 2,
        },
        {
          label: 'CKR Lookup',
          value: 3,
        },
        {
          label: 'CKR Report',
          value: 4,
        },
        // {
        //   label: 'Company Detail Report',
        //   value: 6,
        // },
        {
          label: 'Company Search by Name',
          value: 5,
        },
        {
          label: 'Company Search by Ticker',
          value: 8,
        },
        {
          label: 'Company Search by Phone',
          value: 9,
        },
        {
          label: 'Company Financial Report',
          value: 7,
        },
      ],
      btnLoading: false,
      defaultQuery: '',
    }
  },
  computed: {
    disposeProductNameList() {
      const bureauNameValue = this.form.bureauName
      let arr = null
      switch (bureauNameValue) {
        case 1:
          arr = this.productNameList.filter(item =>
            BRAZIL_VALUES.includes(item.value),
          )
          break
        case 2:
          arr = this.productNameList.filter(item =>
            BRADSTREET_GLOBAL_VALUES.includes(item.value),
          )
          break
        case 3:
          arr = this.productNameList.filter(item =>
            CREDIT_RISK_MONITOR_VALUES.includes(item.value),
          )
          break
      }
      return arr
    },
  },
  created() {
    // 处理从详情直接跳转到新增页面
    if (this.$route.query.dunsNumber) {
      this.form.productName = 2
    }
    if (this.$route.query.businessId) {
      // this.$route.query.businessId = this.$route.query.crmzBusinessId
      this.form.bureauName = 3
      this.form.productName = 7
    }
    // 处理从详情直接跳转到新增页面
    if (this.$route.query.queryId) {
      this.form.bureauName = 1
      this.handleBureauNameSelectChange()
      this.form.productName = 4
      this.defaultQuery = this.$route.query.queryId
    }
  },
  components: {
    BrazilLookup,
    BrazilReport,
    GlobalLookup,
    GlobalDataPacket,
    MonitorFinancialReport,
    MonitorDetailReport,
    MonitorSearchByName,
    MonitorSearchByTicker,
    MonitorSearchByPhone,
  },
  methods: {
    handleBureauNameSelectChange() {
      const bureauName = this.form.bureauName
      switch (bureauName) {
        case 1:
          this.form.productName = 3
          break
        case 2:
          this.form.productName = 1
          break
        case 3:
          this.form.productName = 5
          break
      }
    },

    async handleClickSubmitBtn() {
      const result = await this.$refs[this.form.productName].validate()
      if (result) {
        this.btnLoading = true
        try {
          let obj = {}
          Object.keys(this.form).forEach(key => {
            let arr = []
            if (key === 'bureauName') {
              arr = this.$cloneDeep(this.bureauNameList)
            } else {
              arr = this.$cloneDeep(this.productNameList)
            }
            const value = arr.filter(item => item.value === this.form[key])[0]
              .label
            if (value) {
              obj[key] = value
            }
          })
          let params = {
            bureauReportSettingBO: { ...result },
            ...obj,
            companyId: this.$route.params.customerId,
          }
          await save(params)
          this.$message.success('success')
          await this.$router.push({
            name: 'bureau-report',
            params: {
              customerId: this.$route.params.customerId,
            },
          })
        } catch (err) {
          console.error(err)
        }
        this.btnLoading = false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.footer {
  margin-top: 24px;
  text-align: right;
}
</style>
